<template>
  <div class="svg-container clouds-wrap">
    <div class="cloud1">
      <img src="@/assets/images/bg/cloud2.svg" class="clouds cloud1-1">
      <img src="@/assets/images/bg/cloud2.svg" class="clouds cloud1-2">
    </div>

    <div class="cloud2">
      <img src="@/assets/images/bg/cloud1.svg" class="clouds cloud2-1">
      <img src="@/assets/images/bg/cloud1.svg" class="clouds cloud2-2">
    </div>
    <div class="cloud3">
      <img src="@/assets/images/bg/cloud2.svg" class="clouds cloud3-1">
      <img src="@/assets/images/bg/cloud2.svg" class="clouds cloud3-2">
    </div>
    <div class="cloud4">
      <img src="@/assets/images/bg/cloud2.svg" class="clouds cloud4-1">
      <img src="@/assets/images/bg/cloud2.svg" class="clouds cloud4-2">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Clouds'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .svg-container {
    position: absolute;
    top: 0;
    z-index: 0;
    width: 100%;
  }

  .clouds {
    position: absolute;
  }

  .cloud1-1 {
    width: 172px;
    left: 105%;
  }

  .cloud1-2 {
    width: 172px;
    left: 105%;
  }

  .cloud2-1 {
    width: 185px;
    top: 26px;
    left: 105%;
  }

  .cloud2-2 {
    width: 185px;
    top: 26px;
    left: 105%;
  }

  .cloud3-1 {
    width: 240px;
    top: 50px;
    left: 105%;
  }

  .cloud3-2 {
    width: 240px;
    top: 50px;
    left: 105%;
  }

  .cloud4-1 {
    width: 244px;
    left: 105%;
    top: 12px;
  }

  .cloud4-2 {
    width: 244px;
    right: -1195px;
    top: 12px;
  }

  .clouds-wrap {
    width: 100vw;
    height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/Background/Clouds.vue